import { createSelector } from 'reselect';
import type { DnsEntryReducerState } from './types';

/**
 * dnsSetupSelector
 * Selector for the dnsSetup state.
 * @param { Object } state: The application state.
 * @returns { Object } The dnsSetup state.
 */
export const getDnsSetup = (state: { settings: { dnsSetup: DnsEntryReducerState } }) =>
  state.settings.dnsSetup;

/**
 * selectDnsSetupEntriesForCSV
 * Selects the entries data from state.
 * @param { Object } state: The application state.
 * @returns { Any } The value of entries from the dnsSetup state.
 */
export const selectDnsSetupEntriesForCSV = createSelector([getDnsSetup], (dnsSetup) => {
  const { entries } = dnsSetup;
  return entries.map((entry) => {
    const hasEntryText = entry.hasEntry ? 'Yes' : 'Not Yet';
    return { ...entry, hasEntry: hasEntryText };
  });
});
